'use client';

import CookieBanner from '@/components/CookieBanner';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import MobileBookingBar from '@/components/MobileBookingBar';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { usePathname } from 'next/navigation';
import { AuthProvider } from '@/context/AuthContext';
import { LocaleProvider } from '@/context/LocaleContext';
import { isBookingPath } from '@/lib/locale';

export default function Providers({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const inBookingApp = isBookingPath(pathname);

  return (
    <AuthProvider>
      <LocaleProvider>
        {children}
        {!inBookingApp && <CookieBanner />}
        <GoogleAnalytics />
        {!inBookingApp && <MobileBookingBar />}
        {!inBookingApp && <WhatsAppFloat />}
      </LocaleProvider>
    </AuthProvider>
  );
}
